import React, { Component } from 'react';
import { connect } from 'react-redux';
import { login } from '../../api/api';
import translate from '../../i18n/translate';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

class OrderDetails extends Component {
  state = {
    order: null,
    loading: true,
    error: null,
  };

  componentDidMount() {
    // Assuming 'orderId' is passed via route params
    const search = new URLSearchParams(window.location.search);
    const orderId = search.get('orderId');
    const userEmail = search.get('userEmail');
    console.log(window.location.search);
    console.log(orderId, userEmail);
    this.fetchOrderDetails(orderId, userEmail);
  }

  fetchOrderDetails = async (orderId, userEmail) => {
    try {
      const response = await login({externalReference: orderId, recipientCriteria: userEmail});
      this.setState({ order: response.data, loading: false });
    } catch (error) {
      this.setState({ error: translate('error_fetching_order'), loading: false });
    }
  };

  render() {
    const { order, loading, error } = this.state;

    if (loading) {
      return <div>{translate('loading')}</div>;
    }

    if (error) {
      return <div>{error}</div>;
    }

    return (
      <Container>
        <h1>{translate('order_details')}</h1>
        <p>{translate('order_id')}: {order.orderId}</p>
        <p>{translate('status')}: {order.status}</p>
        {/* Add more order details as needed */}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  // Map necessary state if required
});

export default connect(mapStateToProps)(OrderDetails);